import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { Asset } from '../Models/asset';

@Injectable({
  providedIn: 'root'
})
export class AssetService {

  // The base path for the asset API, matches your Route::apiResource
  private resourcePath = 'assets';

  constructor(private apiService: ApiService) { }

  /**
   * Get a paginated or filtered list of assets.
   * @param queryParams Optional HTTP parameters for filtering, sorting, etc.
   */
  getAssets(queryParams?: HttpParams): Observable<Asset[]> {
    return this.apiService.get(this.resourcePath, queryParams);
  }

  /**
   * Get a single asset by its ID.
   * @param id The ID of the asset.
   */
  getAsset(id: number): Observable<Asset> {
    return this.apiService.get(`${this.resourcePath}/${id}`);
  }

  /**
   * Create a new asset.
   * @param data The asset data to create.
   */
  createAsset(data: Asset): Observable<Asset> {
    return this.apiService.post(this.resourcePath, data);
  }

  /**
   * Update an existing asset.
   * @param id The ID of the asset to update.
   * @param data The new asset data.
   */
  updateAsset(id: number, data: Partial<Asset>): Observable<Asset> {
    return this.apiService.update(`${this.resourcePath}/${id}`, data);
  }

  /**
   * Delete an asset by its ID.
   * @param id The ID of the asset to delete.
   */
  deleteAsset(id: number): Observable<any> {
    return this.apiService.delete(`${this.resourcePath}/${id}`);
  }
}
